import { EventBus } from "../../../eventbus";
import { userHasAllRights } from "../../../functions/userRights";

export default {
  props: {
    id: String,
    parentId: String,
    options: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      show: false,
      headerSettings: false,
      activeOptions: [],
      optionsData: {},
      blackList: [],
    };
  },
  created() {
    //listen for open and close events
    EventBus.$on(`${this.$options.name}-show`, (data) => {
      if (this.id === data.id) {
        //is for here so set the show value
        this.setShow(data.show);

        //set extra values if needed
        if (data.title) {
          this.headerSettings = data;
        }

        //set all variables in this section used for forwarding data to otgher components
        this.optionsData = data;

        //update blacklist
        if (data.blackList) {
          this.blackList = data.blackList;
        } else {
          this.blackList = [];
        }
      } else {
        //hides all other topOptions
        this.setShow(false);
      }
    });

    this.setActiveOptions();
  },

  methods: {
    updateSelf(show) {
      EventBus.$emit(`${this.$options.name}-show`, {
        id: this.id,
        show: show,
      });
    },
    setShow(show) {
      if (this.activeOptions.length) {
        if (this.show === "toggle") {
          this.show = !this.show;
        } else {
          this.show = show;
        }
      } else {
        this.show = false;
      }
    },
    setActiveOptions() {
      this.activeOptions = this.options.filter((option) => {
        if (option.rights) {
          //check if rights are all met
          return userHasAllRights(option.rights, this);
        } else {
          return true;
        }
      });
    },
    checkOptionRights(rights) {
      if (rights) {
        return userHasAllRights(rights, this);
      } else {
        return true;
      }
    },
  },
  watch: {
    options() {
      this.setActiveOptions();
    },
  },
};
